import { PlaceholdersId, TFComponent } from '@types';
import { TitleDocumentTermsConditionPlaceholder } from './titleDocumentTermsCondition';

export const titleDocumentTermsCondition: TFComponent = {
	component: TitleDocumentTermsConditionPlaceholder,
	id: PlaceholdersId.titleDocumentTermsCondition,
	name: 'titleDocumentTermsCondition',
};
